import { DivProps } from '../../../../../typings';
import Fouls from './fouls';
import { PanelItemWrapper } from './styles';
import PlayersList from './playersList';
import Score from './score';
import UDText from 'ud-ui/components/text';
import { selectPeriod } from 'modules/stream/store/time/selectors';
import useGameInfo from '../../hooks/use-game-info';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

interface IProps extends DivProps {
  teamIndex: number;
}

function TeamPanel(props: IProps) {
  const { teamIndex, ...rest } = props;

  const { teams } = useGameInfo();
  const period = useSelector(selectPeriod);

  const team = useMemo(() => {
    if (teamIndex === 0) return teams?.first;
    if (teamIndex === 1) return teams?.second;
  }, [teamIndex, teams]);

  return (
    <PanelItemWrapper {...rest}>
      <div className={'flex-center w-full'}>
        <UDText type={'headline'} color={'#686A79'}>
          {team?.name ?? 'Неизвестная команда'}
        </UDText>
      </div>

      <div className={'flex flex-row flex-wrap gap-8'}>
        <div className={'flex flex-col grow'}>
          <Score className={'mt-2'} teamIndex={teamIndex} />
          <Fouls className={'mt-2'} teamIndex={teamIndex} period={period} />
        </div>
        <div>
          <PlayersList teamIndex={teamIndex} />
        </div>
      </div>
    </PanelItemWrapper>
  );
}

export default TeamPanel;
